<template>
    <div class="container">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle"> </div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src class="nav-img none" />
        </div>
      </div>

      <div class="top ub"></div>
      <div class="to-index ub ub-pc ub-ac" v-if="!router_url">
          <div class="ub ub-ac ub-pc btn" @click="goto_index()"><span>去聊天</span></div>
      </div>
      <div class="rules ub ub-ae"><div class="rules_btn" @click="rules()">邀请规则</div></div>
      <div class="content">
        
        <div class="invite-block">
         <div class="middle-txt ub ub-pc ub-ac">
            <div class="d1"></div>
            <span>奖励说明</span>
            <div class="d2"></div>
         </div>
         <div class="sum_block ub ub-ver ub-ac ub-pc">
          
          <span class="sum">40<a>%</a></span>
          <span class="tip2">邀请好友收益高达</span>
         </div>
          <ul class="prize ub ub-ac3">
              <li class="item ub ub-ver ub-pc">
                <div class="percentage ub ub-ac ub-pc">
                  <div class="ub ub-pe">10<a>%</a></div>
                </div>
                <div class="title ub ub-ac ub-pc">充值奖励</div>
                <span class="tip">好友每次充值的10%<br/>包括充值会员和金币</span>
              </li>
              <li class="jia ub ub-ac ub-pc">+</li>
              <li class="item ub ub-ver ub-pc">
                <div class="percentage ub ub-ac ub-pc">
                  <div class="ub ub-pe">10<a>%</a></div>
                </div>
                <div class="title ub ub-ac ub-pc">礼物奖励</div>
                <span class="tip">好友礼物收入的10%<br/>包括全平台的礼物</span>
              </li>
              <li class="jia ub ub-ac ub-pc">+</li>
              <li class="item ub ub-ver ub-pc">
                <div class="percentage ub ub-ac ub-pc">
                  <div class="ub ub-pe">20<a>%</a></div>
                </div>
                <div class="title ub ub-ac ub-pc">私信奖励</div>
                <span class="tip">好友私信收入的20%<br/>包括全部私信</span>
              </li>
          </ul>

          <div class="share_block ub ub-ac ub-pc">
            <ul class="ub ub-ac1 ub-pc">
              <li class="item" @click="copy()">复制链接</li>
              <li class="item" @click="share()">分享链接</li>
              <li class="item" @click="poster()">分享海报</li>
            </ul>
          </div>
        </div>

        
  
        <div class="invitation-benefits">
            <div class="middle-txt ub ub-pc ub-ac">
                <div class="d1"></div>
                    <span>我的佣金</span>
                <div class="d2"></div>
            </div>
  
            <div class="invite-num ub ub-ac2">
              <div class="item ub ub-ver ub-ac ub-pc" @click="goto('invite_friends')">
                  <div class="ub ub-pe">{{ friends_num }}<a>人</a></div>
                  <span>我的邀请</span>
              </div>

              <div class="ub ub-f1"></div>

              <div class="item ub ub-ver ub-ac ub-pc" @click="goto('invite_profit')">
                  <div class="ub ub-pe">{{ profit_num }}<a>元</a></div>
                  <span>我的收益</span>
              </div>
            </div>

            <div class="ub ub-ver ub-ac ub-pc" v-if="my_friends.length > 0">
              <table border="1">
                <tr>
                    <th>头像</th>
                    <th>昵称</th>
                    <th>性别</th>
                    <th>时间</th>
                    <th>注册</th>
                </tr>
        
                <tr v-for="(item, index) in my_friends" :key="index">
                    <td>
                      <img class="photo" v-if="item.photo" :src="item.photo" alt="" />
                    </td>
                    <td>
                      <span class="name">{{ item.nick.length > 4 ? item.nick.substr(0,4) + '...' : item.nick }}</span>
                    </td>
                    <td><span>{{ item.sex }}</span></td>
                    <td>
                      <span v-if="item.dtm_hour < 1">刚刚</span>
                      <span v-if="item.dtm_hour >= 1 && item.dtm_hour < 24">{{ Math.floor(item.dtm_hour) }}小时</span>
                      <span v-if="item.dtm_hour >= 24">{{ Math.floor(item.dtm_hour / 24) }}天</span>
                    </td>
                    <td>
                      <span v-if="item.reg_complete == 1">已完成</span>
                      <span v-if="item.reg_complete == 0">未完成</span>
                    </td>
                </tr>
              </table>
                <div class="ub ub-ac ub-pc more">
                  <span @click="goto('invite_friends')">查看更多</span>
                </div>

            </div>
        </div>
  
        <div class="ub ub-pc ub-ac">
          <div class="xhc-tips ub ub-ac ub-pc">
              <span>*本次活动最终解释权归小火柴所有</span>
          </div>
        </div>

      </div>
  
      <alert ref="myConfirm" ></alert>
      <guide ref="myGuide"></guide>
      <reward_coin ref="show_reward_coin"></reward_coin>
    </div>
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../../api/common";
  import Alert from "../../components/Form.vue";
  import Guide from "../../components/Guide.vue";
  import Coin_Reward from "../../components/Coin_Reward.vue";
  export default {
    components: {
      alert: Alert,
      guide: Guide,
      reward_coin: Coin_Reward
    },
    data() {
      return {
        my_friends:[],
        friends_num: 0,
        profit_num: 0.00,
        invite_url: "",
        router_url: ""
      };
    },
    mounted() {
      this.loading("加载中...",5000);
      this.init_page();
      var self = this;
      setTimeout(()=>{
        self.init_share();
      },100)
    },
    beforeRouteEnter(to, from, next) {
    next(vm=>{
        vm.router_url = from.name;
      })
    },
    methods: {
      ...mapMutations(["get", "post", "WxConfig", "wxShare"]), //引入方法
      ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
  
      back() {
        if (!this.router_url) {
          this.$router.push({ name: "index" });
          return true;
        }
        this.$router.go(-1); //返回上一层
      },
  
      init_page() {
        var uid = this.$store.state.uid;
        //分享链接
        this.invite_url = `你的好友正在玩儿小火柴，邀请你一起来匿名聊天\n第一步：关注微信公众号【小火柴聊聊】\n↓\n第二步：点击下方菜单【全新版】，完成注册流程\n↓\n点击前往\n${window.location.origin}/index2?id=${uid}#`;

        var invite_sum = this.$store.state.http_cache.invite_sum;
        var dtm = invite_sum.dtm;
        var dtm_now = new Date().getTime();
        var timeDiff = (dtm_now - dtm ) / (1000 * 60); //相差时间
        //使用缓存数据
        if (timeDiff < 10) {
          if (invite_sum.data_serve.fried_count > 0) {
            this.init_inviteList();
          }
          this.$loading.close();
          this.friends_num = invite_sum.data_serve.fried_count;
          this.profit_num = (invite_sum.data_serve.score_total / 1000).toFixed(2);
          return false;
        }

        //使用接口数据
        var self = this;
        self.get({
          url: "/App/GetInviteSum_Data?uid=" + uid,
          success: function(data) {
            self.$loading.close();
            if (data.fried_count > 0) {
              self.init_inviteList();
            }
            //首次邀请奖励
            if (data.coin_invite == 0 && data.fried_count > 0) {
              self.receive_first_invite();
            }
            var obj = {
              dtm: new Date().getTime(),
              data_serve: data
            }
            self.$store.commit("set_http_cache", {invite_sum: obj});
            self.friends_num = data.fried_count;
            self.profit_num = (data.score_total / 1000).toFixed(2);
          },
          error: function(res) {}
        });
      },

      receive_first_invite() {
        var reward = {
          "type": "首次邀请",
          "coin": 300,
          "tips": "首次邀请成功，即可获得300金币奖励。",
          "path_name":"",
          "btn_name":"收下"
        }
        this.$refs.show_reward_coin.show(reward);

        //后台领取
        var uid = this.$store.state.uid;
        var self = this;
        self.get({
          url: "/App/Create_InviteFriend_Coin?uid=" + uid + "&coin=300",
          success: function(data) {
            if (data.state == 1) {
              self.act_reload_userinfo();
              
              var invite_sum = self.$store.state.http_cache.invite_sum;
              var obj = {
                dtm: new Date().getTime(),
                data_serve: {
                  ...invite_sum.data_serve,
                  coin_invite: 300
                }
              };
              self.$store.commit("set_http_cache", { invite_sum: obj });
            }
          },
          error: function(res) {}
        });
      },

      init_inviteList() {
        var uid = this.$store.state.uid;
        var self = this;
        self.get({
          url: "/App/GetInviteList_Friends?uid=" + uid + "&size=3",
          success: function(data) {
            for (var i = 0; i < data.length; i++) {
              var user = data[i];
              //初始化数据
              user.photo = self.$store.state.url + "/photo/" + user.photo;
              user.dtm = user.create_time.replace(/-/g, "/");
              user.create_time = new Date(user.create_time);
              var second = tool.dateDiff_Now(user.create_time);
              user.dtm_hour = Math.floor(second / 3600);
            }
            self.my_friends = data;
          },
          error: function(res) {}
        });
      },

      init_share() {
        this.WxConfig({url:window.location.href});
      },

      share() {
        var url = this.$store.state.url;
        var uid = this.$store.state.uid;
        var path = `${window.location.origin}/index2?id=${uid}#`;
          var shareParam = {
              title: "一起来玩儿小火柴",
              desc: "来小火柴，遇见有温度的陌生人",
              link: path,
              imgUrl: url + "/photo/admin_logo.png"
          };
          this.wxShare(shareParam);
          this.$refs.myGuide.show();
      },

      goto(name) {
        this.$router.push({ name: name });
      },
  
      //活动规则
      rules() {
        var self = this;
        var h =
          '<div style="display: flex; flex-direction: column; font-size:.9rem; overflow:scroll;width: 99.5%;border-radius:.3em;color: #888;">'  +
          
          "<span>1、首次邀请成功，即可获得300金币奖励。</span>" +
          "<span>2、邀请的好友每次充值，将获得充值金额10%的现金奖励; 邀请的好友每次收到礼物，将获得礼物收益的10%; 邀请的好友每次私信收入，将获得私信收益的20% 。</span>" +
          "<span>3、奖励的金币和积分自动到账，积分可立即提现。</span>" +
          "<span>积分奖励举例:</span>" +
          "<span>您邀请的好友充值1万元人民币，您得10%即1000000积分，可提现约1000元;</span>" +
          "<span>您邀请的好友收到礼物获得1万元人民币，您得10%即1000000积分，可提现约1000元;</span>" +
          "<span>您邀请的好友私聊收益获得1万元人民币，您得20%即2000000积分，可提现约2000元。</span>" +
          "<span>如果被邀请用户连续90天不登录，则自动解绑。</span>" 
          + '</div>';
        self.$refs.myConfirm.show(h, {
          type: "alert",
          confirmText: "知道了",
          titleText: "邀请规则",
          data: ""
        });
      },
      
      copy() {
        var text = this.invite_url;
        this.copyText(text);
      },

      //复制内容到粘贴板
      copyText(text) {
        var self = this;
        // 创建一个临时文本区域来复制文本
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed'; // 避免页面滚动
        textarea.style.opacity = '0'; // 隐藏元素
        document.body.appendChild(textarea);
        textarea.select(); // 选中文本

        try {
          // 执行复制命令
          if (document.execCommand('copy')) {
            self.$toast.center("复制成功");
          } else {
            self.$toast.center("复制失败");
          }
        } catch (err) {
          self.$toast.center("复制失败");
        }

        // 移除临时文本区域
        document.body.removeChild(textarea);
      },

      poster() {
        this.$toast.center("敬请期待");
      },

      loading(title,time) {
        var self = this;
          this.$loading(title);
          setTimeout(() => {
              self.$loading.close();
          }, time);
      },

      goto_index() {
        this.$router.push({ name: "index" });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background-color: #efefef;
  }

  .nav-top {
    background-color: transparent;
  }
  
  .top {
    margin-top: -2.6rem;
    height: 14rem;
    background-image: url(../../assets/img/new2024/invite-friendsTop.png);
    background-size:cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .rules {
      background-color: #FF6203;
      padding: 0.3rem 0;
      color: #fff;
      font-size: 0.9rem;
      .rules_btn {
        padding: 0.3rem 0.5rem;
        background-color: #FCB620;
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
      }
    }

  .content {
    padding: 0 0.8rem;
    background-color: #FF6203;
    
    .middle-txt {
      .d1 {
        background-image: linear-gradient(to right, #FDFDFD, #ba61ff);
        height: 4px;
        width: 5rem;
      }
      .d2 {
        background-image: linear-gradient(to left, #FDFDFD, #ba61ff);
        height: 4px;
        width: 5rem;
      }
      span {
        font-size: 1.3rem;
        font-weight: bold;
        margin: 0 1.5rem;
        color: #ba61ff;
      }
    }
    .invite-block {
          padding: 1rem 0;
          background-color: #FDFDFD;
          border-radius: 0.5rem;
          .sum_block {
            margin-top: 1rem;
            .tip {
              font-size: 0.9rem;
              color: #E43C3A;
            }
            .sum {
              font-size: 4rem;
              font-weight: bold;
              color: #FE5E2C;
              a{
                margin-left: 0.1rem;
                font-size: 1rem;
                line-height: 1.7rem;
              }
            }
            .tip2 {
              font-size: 0.75rem;
              font-weight: 800;
              color: #ED6E2E;
            }
          }
          .prize {
            margin-top: 0.5rem;
              .item {
                width: 7rem;
                .percentage {
                    width: 5rem;
                    height: 5rem;
                    border-radius: 50%;
                    background: linear-gradient( 180deg, #FDFDFD, #FDE345 );
                    font-size: 1.8rem;
                    font-weight: bold;
                    color: #FF6203;
                    a{
                      margin-left: 0.1rem;
                      font-size: 1rem;
                      line-height: 1.7rem;
                    }
                }
                .title {
                    margin-top: -0.5rem;
                    width: 5rem;
                    height: 1.5rem;
                    border-radius: 1rem;
                    background-color: #FF6203;
                    font-size: 0.9rem;
                    color: #FDFDFD;
                }
                .tip {
                    margin-top: 0.5rem;
                    font-size: 0.65rem;
                    color: #666;
                    word-wrap:break-word; 
                }
              }
              .jia {
                margin-bottom: 4rem;
                font-size: 1.8rem;
                font-weight: bold;
                color: #FF6203;
              }
          }
          .share_block {
            margin-top: 2rem;
            background-color: #FDFDFD;
            ul {
              width: 100%;
            }
            .item {
              padding: 0.5rem 1.5rem;
              background-color: #FF6E05;
              border-radius: 2rem;
              color: #fff;
            }
          }
    }

      .invitation-benefits {
          margin-top: 1rem;
          padding: 0.8rem;
          background-color: #FDFDFD;
          border-radius: 0.5rem;
          .invite-num {
            margin-top: 0.5rem;
            .item {
              width: 45%;
              height: 5rem;
              background: linear-gradient( 60deg, #FF6E05, #FCB620);
              border-radius: 0.5rem;
              font-size: 1.7rem;
              font-weight: bold;
              color: #fff;
              a {
                margin-left: 0.1rem;
                font-size: 0.75rem;
                line-height: 1.6rem;
              }
              span {
                margin-top: 0.5rem;
                font-size: 0.75rem;
                color: #dfdddd;
              }
            }
          }
          table {
          margin: 0.5rem 0;
          width: 100%;
          border-collapse: collapse;
          border: 1px solid rgb(211 208 208);
            th {
              height: 2rem;
              background-color: rgb(237, 236, 252);
              font-size: 0.9rem;
            }
            td {
              padding: 0.8rem;
              font-size: 0.75rem;
              color: #333;
              word-wrap:break-word; 
              .photo {
                width: 2.5rem;
                height: 2.5rem;
                border-radius: 50%;
              }
            }
          }
          .more {
            font-size: 0.75rem;
            color: #333;
          }
      }

      .xhc-tips {
          padding: 1rem 0;
          span {
              font-size: 0.75rem;
              color: #fff;
          }
      }
  }

  .to-index {
    position: fixed;
    top: 12rem;
    right: 0;
    left: 0;
    margin: 0 auto;
    .btn {
      width: 15rem;
      height: 2.5rem;
      border-radius: 1rem;
      background-color: rgba(162, 100, 231, 0.5);
      span {
        font-size: 0.75rem;
        color: #FFFFFF;
      }
    }
  }
  </style>